// https://confluence.vk.team/pages/viewpage.action?pageId=1560502237
export enum CloudActions {
    FILE_CREATE = 'file_create',
    FILE_VERSION_RESTORE = 'file_version_restore',
    FILE_READ = 'file_read',
    FILE_EDIT = 'file_edit',
}
